const prefix = "";

const apis = {
  login: {
    signIn: `${prefix}/login`,
    logout: `${prefix}/logout`,
  },
  user: {
    accountInfo: `${prefix}/user/self/account_info`,
    userAccount: `${prefix}/user/self/user_account`,
    userAccountDetail: `${prefix}/user/self/user_account_detail`,
    userAccountById: `${prefix}/user/user_account`,
    allTeacherAccount: `${prefix}/user/teachers`,
    changePassword: `${prefix}/user/self/change_password`,
    createUser: `${prefix}/user/register`,
    userAgentInfo: `${prefix}/user/agents`,
    userFileInfo: `${prefix}/user/user_file`,
    uploadUserFile: `${prefix}/user/user_file/upload`,
    deleteUserFile: `${prefix}/user/user_file/remove`,
    downloadUserFile: `${prefix}/user/user_file/download`,
    exportUserFile: `${prefix}/user/export`,
    importUserFile: `${prefix}/user/import`,
    resetUserPassword: `${prefix}/user/reset_password`,
    facultyAccount: `${prefix}/user/self/faculty_account`,
    importFacultyFile: `${prefix}/user/import/faculty`,
  },
  student: {
    allClass: `${prefix}/student/all_class`,
    allStudent: `${prefix}/student/all`,
    classInfo: `${prefix}/student/class`,
    allStudentByClass: `${prefix}/student/by_class`,
    changeClass: `${prefix}/student/change_class`,
    timePeriod: `${prefix}/student/time_period`,
  },
  leave: {
    leaveInfo: `${prefix}/leave`,
  },
  rent: {
    placeInfo: `${prefix}/rent/public_place`,
    deletePlaceInfo: `${prefix}/rent/public_place_history`,
    itemGroupInfo: `${prefix}/rent/public_item_group`,
    allItemInfo: `${prefix}/rent/public_items`,
    itemInfo: `${prefix}/rent/public_item`,
    rentItem: `${prefix}/rent/public_items_rent_history`,
  },
  sale: {
    allSaleGroupInfo: `${prefix}/sale/sale_groups`,
    saleGroupInfo: `${prefix}/sale/sale_group`,
    allSaleProductInfo: `${prefix}/sale/sale_items`,
    saleProductInfo: `${prefix}/sale/sale_item`,
    purchase: `${prefix}/sale/purchase`,
    balanceInfo: `${prefix}/sale/balance`,
    saleHistory: `${prefix}/sale/sale_history`,
    exportSaleHistory: `${prefix}/sale/export_sale_history`,
    saleSubjectInfo: `${prefix}/sale/sale_subject`,
    allUserBalance: `${prefix}/sale/all_user_balance`,
  },
  bus: {
    busTimeInfo: `${prefix}/bus_time`,
    schoolInfo: `${prefix}/bus_time/school`,
    studentInfo: `${prefix}/bus_time/take_school_bus/students`,
    studentStatus: `${prefix}/bus_time/take_school_bus/student/status`,
    studentTakeBus: `${prefix}/bus_time/take_school_bus`,
  },
  lostAndFound: {
    allLostItem: `${prefix}/lost_and_found/all_items`,
    lostItemInfo: `${prefix}/lost_and_found`,
  },
  attendance: {
    signInfo: `${prefix}/attendance/sign_in_records`,
    signIn: `${prefix}/attendance/sign_in`,
    cancelSignIn: `${prefix}/attendance/cancel_sign_in`,
  },
  selfStudy: {
    allPeriodInfo: `${prefix}/self_study/all_period`,
    periodInfoById: `${prefix}/self_study/user_period`,
    updateStudyPeriodInfo: `${prefix}/self_study/modify_study_period`,
  },
  announcement: {
    announcementInfo: `${prefix}/announcement`,
    allClassroomInfo: `${prefix}/announcement/all_classroom`,
    calendarInfo: `${prefix}/announcement/calendar`,
    exportCalendar: `${prefix}/announcement/calendar/export`,
    importCalendarFile: `${prefix}/announcement/calendar/import`,
    classroomCountingPeople: `${prefix}/announcement/classroom_counting_people`,
  },
  rollCall: {
    rollCallGroup: `${prefix}/service_system/roll_call_group`,
    rollCallInfo: `${prefix}/service_system/roll_call_mapping`,
    updateRollCall: `${prefix}/service_system/roll_call`,
    vacationAndMakeUpDay: `${prefix}/service_system/vacation_and_make_up_day`,
  },
  department: {
    departmentInfo: `${prefix}/department`,
  },
  role: {
    roleInfo: `${prefix}/role`,
  },
  permission: {
    permissionInfo: `${prefix}/permission`,
    rolePermissionInfo: `${prefix}/permission/role_permission`,
  },
  document: {
    allDocumentInfo: `${prefix}/document/all`,
    createDocument: `${prefix}/document/upload`,
    updateDocument: `${prefix}/document/personType`,
    deleteDocument: `${prefix}/document/remove`,
    downloadDocument: `${prefix}/document/download`,
  },
  media: {
    mediaInfo: `${prefix}/media`,
    uploadMedia: `${prefix}/media/upload`,
  },
  subject: {
    subjectInfo: `${prefix}/subject`,
  },
  semester: {
    semesterInfos: `${prefix}/semester/group_by_year`,
    semesterInfosByYear: `${prefix}/semester/by_year`,
    semesterInfosById: `${prefix}/semester/by_id`,
    semesterInfo: `${prefix}/semester`,
    examInfo: `${prefix}/semester/exam`,
  },
  section: {
    classInfo: `${prefix}/class`,
    classSubjectInfo: `${prefix}/class/subject_list`,
    updateClassSubject: `${prefix}/class/subject`,
    classInfoByUserAccountId: `${prefix}/class/by_user_account`,
  },
  classTimePeriod: {
    classTimePeriodInfos: `${prefix}/class_time_period/group_by_year`,
    classTimePeriodInfo: `${prefix}/class_time_period`,
  },
  transcript: {
    transcriptList: `${prefix}/transcript`,
    transcriptListImport: `${prefix}/transcript/import`,
  },
  archived: {
    archivedTranscript: `${prefix}/archived/transcript`,
  },
}

export default apis;